import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "@arcgis/core/assets/esri/themes/light/main.css";
import "./index.css"; //
import esriConfig from "@arcgis/core/config";
import * as esriConfigLoc from "@arcgis/core/intl";
import * as urlUtils from "@arcgis/core/core/urlUtils";
import reportWebVitals from "./reportWebVitals";
import "./i18n/config";
import i18n from "i18next";
import App from "./App";
import CommonFunctions from "./Utils/CommonFunctions";
import "animate.css";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";

if (isMobile) {
  let urlPath = process.env.REACT_APP_BASE_URL + "/css/style.css";
  var cssId = "myCss1"; // you could encode the css path itself to generate id..
  var linkNode = document.getElementById(cssId);
  if (linkNode != null) {
    linkNode.parentNode.removeChild(linkNode);
  }
  if (!document.getElementById(cssId)) {
    var head = document.getElementsByTagName("head")[0];
    var link = document.createElement("link");
    link.id = cssId;
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = urlPath;
    link.media = "all";
    head.appendChild(link);
  }
}
const root = ReactDOM.createRoot(document.getElementById("root"));
const language = CommonFunctions.getSelectedLanguage();

i18n.changeLanguage(language);

let theme = CommonFunctions.renderThemeName();

function LoadCSS(cssFileName) {
  var urlPath =
    process.env.REACT_APP_cmsRootUrl + "wp-content/themes/Atlas%20theme/css/";
  var cssId = "myCss"; // you could encode the css path itself to generate id..
  var linkNode = document.getElementById(cssId);
  if (linkNode != null) {
    linkNode.parentNode.removeChild(linkNode);
  }
  if (!document.getElementById(cssId)) {
    var head = document.getElementsByTagName("head")[0];
    var link = document.createElement("link");
    link.id = cssId;
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = urlPath + cssFileName + "?v=" + Date.now();
    link.media = "all";
    head.appendChild(link);
  }
}

function setvariables() {
  let theme = CommonFunctions.renderThemeName();
  let language = CommonFunctions.getSelectedLanguage();
  // start login open for public
  var LoginSession = true;
  //   sessionStorage.getItem("session") == null
  //     ? false
  //     : sessionStorage.getItem("session");
  // // end login open for public
  sessionStorage.setItem("theme", theme);
  document.getElementById("root").className = "";
  if (theme != null) {
    document
      .getElementById("root")
      .classList.add(theme.toLowerCase() + "_main");
  } else {
    document.getElementById("root").classList.add("static_main");
  }
  if (theme != null) {
    if (process.env.REACT_APP_portalUrl != "") {
      esriConfig.portalUrl = process.env.REACT_APP_portalUrl;
    }

    if (LoginSession == false && !isMobile) {
      window.location.href = process.env.REACT_APP_BASE_URL + "/Index";
    }
    if (process.env.REACT_APP_portalUrl != "") {
      esriConfig.portalUrl = process.env.REACT_APP_portalUrl;
    }

    //proxy Url setting start
    if (process.env.REACT_APP_SupportProxy == true) {
      if (process.env.REACT_APP_proxyUrl != "") {
        urlUtils.addProxyRule({
          urlPrefix: process.env.REACT_APP_portalUrl,
          proxyUrl: process.env.REACT_APP_proxyUrl,
        });
        urlUtils.addProxyRule({
          urlPrefix: process.env.REACT_APP_serverPrefix,
          proxyUrl: process.env.REACT_APP_proxyUrl,
        });
      }
    }
    //proxy Url setting start
    if (process.env.REACT_APP_assetsPath != "") {
      esriConfig.assetsPath =
        process.env.REACT_APP_BASE_URL + process.env.REACT_APP_assetsPath;
    }
    if (process.env.REACT_APP_Fontsurl != "") {
      esriConfig.fontsUrl = process.env.REACT_APP_Fontsurl;
    }
    if (language == "ar") {
      esriConfigLoc.setLocale("ar");
    }

    if (theme.toLowerCase() == "womenempowerment") {
      LoadCSS("style_we.css");
    } else if (theme.toLowerCase() == "environment") {
      LoadCSS("style_en.css");
    } else if (theme.toLowerCase() == "cultureandheritage") {
      LoadCSS("style_ch.css");
    } else if (theme.toLowerCase() == "infrastructure") {
      LoadCSS("style_in.css");
    } else if (theme.toLowerCase() == "education") {
      LoadCSS("style_ed.css");
    } else if (theme.toLowerCase() == "energy") {
      LoadCSS("style_eg.css");
    } else if (theme.toLowerCase() == "youthempowerment") {
      LoadCSS("style_ye.css");
    } else if (theme.toLowerCase() == "population") {
      LoadCSS("style_po.css");
    } else if (theme.toLowerCase() == "economy") {
      LoadCSS("style_ec.css");
    } else if (theme.toLowerCase() == "futurehorizon") {
      LoadCSS("style_fh.css");
    } else if (theme.toLocaleLowerCase() == "regionalandinternationalcontext") {
      LoadCSS("style_ri.css");
    } else if (theme.toLocaleLowerCase() == "mapsandgazetteer") {
      LoadCSS("style_mg.css");
    }
  }
}
document.addEventListener("scroll", () => {
  const isTop = window.scrollY;
  let btn = document.getElementById("top_button");
  if (btn == null || typeof btn != "undefined") return;
  if (isTop > 300) {
    btn.classList.add("show");
  } else {
    btn.classList.remove("show");
  }
});

document.addEventListener("click", function (e) {
  let language = CommonFunctions.getSelectedLanguage();
  var layerlistcls = document.querySelector(".esri-collapse__icon");
  let index2 =
    e.target.parentNode != null
      ? e.target.parentNode.classList.contains("esri-expand__panel")
      : false;
  let index3 = e.target.classList.contains("esri-collapse__icon");
  let index4 = e.target.classList.contains("esri-expand__mask--expanded");
  var mq = window.matchMedia("screen and (max-width: 768px)");
  var sidebar =
    document.getElementById("sidebarPanel") != null
      ? document.getElementById("sidebarPanel").classList.contains("show")
      : false;
  if (layerlistcls != null && (index2 || index3)) {
    let index1 = layerlistcls.classList.contains("esri-icon-collapse");
    if (mq.matches && !index1) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  } else {
    document.body.style.overflow = "auto";
  }
  if (e.target) {
    let clslist = e.target.classList;
    let index = clslist.contains("menuclose");
    let modalBackdrop = document.getElementById("modalBackdrop");
    if (!index) {
      if (
        document.getElementById("menu") != null &&
        typeof document.getElementById("menu") != "undefined"
      ) {
        document.getElementById("menu").classList.remove("menu_width");
        document.getElementById("menu-bar").classList.remove("change");
        document.getElementById("nav").classList.remove("change");
        document.getElementById("menu-bg").classList.remove("change-bg");
      } else if (
        document.getElementById("sidebarPanel") != null &&
        typeof document.getElementById("sidebarPanel") != "undefined"
      ) {
        let sidebarPanel = document.getElementById("sidebarPanel");
        let body = document.getElementsByTagName("body");
        sidebarPanel.classList.remove("show");
        sidebarPanel.style.display = "none";
        modalBackdrop.style.display = "none";
        body[0].style.overflow = "auto";
      } else {
        modalBackdrop.style.display = "none";
      }
    } else if (isMobile && index) {
      document.body.style.overflow = "hidden";
    }
  }
  let theme = CommonFunctions.renderThemeName();
  if (theme != sessionStorage.getItem("theme")) {
    setvariables();
  }
});

if (theme != null) {
  document.getElementById("root").classList.add(theme.toLowerCase() + "_main");
} else {
  document.getElementById("root").classList.add("static_main");
}
root.render(
  <Suspense fallback={<div className="loader"> </div>}>
    <Helmet>
      <title>{language === "ar" ? "أطلس الاتحاد" : "Union Atlas"}</title>
    </Helmet>
    <App />
  </Suspense>
);
setvariables();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
